var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.486 3c.789 0 1.434.575 1.507 1.315l.007.14V19.77c0 .757-.599 1.376-1.368 1.45l-.146.007h-8.294l.006.053v.922c0 .171.182.405.39.634l.407.432c.059.064.109.123.144.173a.262.262 0 01.102.142l.008.06v.095c0 .124-.09.228-.212.255l-.063.007h-8.13a.27.27 0 01-.266-.202l-.007-.06v-.095a.25.25 0 01.107-.2c.035-.051.085-.11.144-.174l.407-.432c.175-.191.33-.386.377-.544l.015-.091v-.922l.006-.053H1.51C.724 21.223.08 20.649.007 19.91L0 19.77V4.455c0-.758.598-1.378 1.365-1.448L1.51 3h22.976zm.242 1.3H1.272v15.627h23.456V4.3zM13 3.38a.27.27 0 00-.277.265.27.27 0 00.277.264.27.27 0 00.275-.264A.271.271 0 0013 3.38z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/Desktop.0612eaac.svg";
export { ForwardRef as ReactComponent };